import { EVENT_NAMES } from 'constants/eventNames'
import { trackEvent } from 'utils/analyticsService'
import { ANALYTICS_KEYS } from 'constants/analytics-keys'

function onPageLoad(props) {
    trackEvent(
        EVENT_NAMES.PRE_LOAD_SCREEN_WEB,
        'When pre load screens comes up before loading of the test',
        {
            [ANALYTICS_KEYS.SUCCESS]: true,
            [ANALYTICS_KEYS.USER_TEST_ID]: props.testStatus?.testStatus?.data?.userTestId,
        },
    )
}

function landingScreen(props, questions) {
    trackEvent(
        EVENT_NAMES.LANDING_SCREEN_TEST_WEB,
        'User lands on the 1st question of the test',
        {
            [ANALYTICS_KEYS.SUCCESS]: true,
            [ANALYTICS_KEYS.QUESTION_ID]:
                questions[0].questionList[0].question?.questionid,
            [ANALYTICS_KEYS.QUESTION_TYPE]:
                questions[0].questionList[0]?.question?.questionType,
            [ANALYTICS_KEYS.USER_TEST_ID]:
                props?.testStatus?.testStatus?.data?.userTestId,
            [ANALYTICS_KEYS.EXTERNAL_ID]:
                questions[0].questionList[0]?.question?.questionExternalId,
        },
    )
}

function onSectionClick(props, _index) {
    const currentQuestion = props.testData.questionset[_index].questionList[0]
    trackEvent(
        EVENT_NAMES.TAP_SECTION_WEB,
        'User taps on any section in the test',
        {
            [ANALYTICS_KEYS.SUCCESS]: true,
            [ANALYTICS_KEYS.DISCONNECTION_TIME]:
                props.queryparam.disconnect_time * 60,
            [ANALYTICS_KEYS.QUESTION_ID]: currentQuestion.question?.questionid,
            [ANALYTICS_KEYS.QUESTION_TYPE]: currentQuestion.question?.questionType,
            [ANALYTICS_KEYS.EXTERNAL_ID]: currentQuestion.question?.questionExternalId,
            [ANALYTICS_KEYS.USER_TEST_ID]:
                props?.testStatus?.testStatus?.data?.userTestId,
            // what is option selected?, this event trigger when user swtiches from one subject to other
            [ANALYTICS_KEYS.OPTIONS_SELECTED]: currentQuestion.question?.answerbyUser,
            [ANALYTICS_KEYS.SECTION_NAME]:
                props.testData.questionset[_index]?.subject[props.current_language],
        },
    )
}

export { onPageLoad, onSectionClick, landingScreen }
